import { faTrophy, faWifi } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { Image } from 'react-bootstrap';
import confetti from 'canvas-confetti';
import { actualizarResultadosFinal, guardarResultadosFinal } from '@helpers/httpRequests/httpRequestsGruposLectura/httpRequestsGruposLectura';

const LS_KEY = 'competencia_lectura_state';

const guardarEstado = (estado) => {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(estado));
  } catch (e) {
    console.warn('No se pudo guardar en localStorage', e);
  }
};

const recuperarEstado = () => {
  try {
    const raw = localStorage.getItem(LS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

const limpiarEstado = () => localStorage.removeItem(LS_KEY);


const mensajesPruebaqa = [
  { id: crypto.randomUUID(), nombre: 'Ana Martínez',      ppm: 285, comprension: 94, fecha: Date.now(), idPerfil: 4314,    lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Carlos Ramírez',    ppm: 312, comprension: 91, fecha: Date.now(), idPerfil: 4315,    lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Sofía Hernández',   ppm: 267, comprension: 97, fecha: Date.now(), idPerfil: 4331,    lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Luis Fernández',    ppm: 340, comprension: 89, fecha: Date.now(), idPerfil: 4332,  lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Valeria Gómez',     ppm: 298, comprension: 96, fecha: Date.now(), idPerfil: 4333, lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Miguel Torres',     ppm: 255, comprension: 93, fecha: Date.now(), idPerfil: 4334, lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Fernanda Cruz',     ppm: 321, comprension: 95, fecha: Date.now(), idPerfil: 4335, lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Jorge Mendoza',     ppm: 276, comprension: 88, fecha: Date.now(), idPerfil: 4336,   lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Andrea Ruiz',       ppm: 305, comprension: 98, fecha: Date.now(), idPerfil: 4337,   lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Daniel Castro',     ppm: 288, comprension: 90, fecha: Date.now(), idPerfil: 4338,   lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Paola Navarro',     ppm: 350, comprension: 92, fecha: Date.now(), idPerfil: 4339, lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Ricardo Morales',   ppm: 264, comprension: 94, fecha: Date.now(), idPerfil: 4340,  lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Natalia Flores',    ppm: 315, comprension: 99, fecha: Date.now(), idPerfil: 4341,  lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Alejandro Silva',   ppm: 290, comprension: 87, fecha: Date.now(), idPerfil: 4342,  lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Camila Ortega',     ppm: 334, comprension: 96, fecha: Date.now(), idPerfil: 4343, lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Diego Reyes',       ppm: 271, comprension: 91, fecha: Date.now(), idPerfil: 4344,  lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Mariana López',     ppm: 325, comprension: 97, fecha: Date.now(), idPerfil: 4345,  lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'José Aguilar',      ppm: 282, comprension: 89, fecha: Date.now(), idPerfil: 4346,  lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Gabriela Castillo', ppm: 308, comprension: 95, fecha: Date.now(), idPerfil: 4347, lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Emilio Vargas',     ppm: 345, comprension: 93, fecha: Date.now(), idPerfil: 4348, lecturaRand: Math.floor(Math.random() * 12) + 1 },
];


const mensajesPrueba = [
  { id: crypto.randomUUID(), nombre: 'Ana Martínez',      ppm: 285, comprension: 94, fecha: Date.now(), idPerfil: 6,    lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Carlos Ramírez',    ppm: 312, comprension: 91, fecha: Date.now(), idPerfil: 7,    lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Sofía Hernández',   ppm: 267, comprension: 97, fecha: Date.now(), idPerfil: 4,    lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Luis Fernández',    ppm: 340, comprension: 89, fecha: Date.now(), idPerfil: 232,  lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Valeria Gómez',     ppm: 298, comprension: 96, fecha: Date.now(), idPerfil: 4514, lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Miguel Torres',     ppm: 255, comprension: 93, fecha: Date.now(), idPerfil: 4558, lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Fernanda Cruz',     ppm: 321, comprension: 95, fecha: Date.now(), idPerfil: 4573, lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Jorge Mendoza',     ppm: 276, comprension: 88, fecha: Date.now(), idPerfil: 23,   lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Andrea Ruiz',       ppm: 305, comprension: 98, fecha: Date.now(), idPerfil: 42,   lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Daniel Castro',     ppm: 288, comprension: 90, fecha: Date.now(), idPerfil: 62,   lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Paola Navarro',     ppm: 350, comprension: 92, fecha: Date.now(), idPerfil: 4552, lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Ricardo Morales',   ppm: 264, comprension: 94, fecha: Date.now(), idPerfil: 433,  lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Natalia Flores',    ppm: 315, comprension: 99, fecha: Date.now(), idPerfil: 423,  lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Alejandro Silva',   ppm: 290, comprension: 87, fecha: Date.now(), idPerfil: 345,  lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Camila Ortega',     ppm: 334, comprension: 96, fecha: Date.now(), idPerfil: 4553, lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Diego Reyes',       ppm: 271, comprension: 91, fecha: Date.now(), idPerfil: 277,  lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Mariana López',     ppm: 325, comprension: 97, fecha: Date.now(), idPerfil: 756,  lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'José Aguilar',      ppm: 282, comprension: 89, fecha: Date.now(), idPerfil: 982,  lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Gabriela Castillo', ppm: 308, comprension: 95, fecha: Date.now(), idPerfil: 8373, lecturaRand: Math.floor(Math.random() * 12) + 1 },
  { id: crypto.randomUUID(), nombre: 'Emilio Vargas',     ppm: 345, comprension: 93, fecha: Date.now(), idPerfil: 4544, lecturaRand: Math.floor(Math.random() * 12) + 1 },
];

const calcularIEL = (ppm, comprension) => ppm * (comprension / 100);

const medalColor = { 0: '#FFD700', 1: '#C0C0C0', 2: '#CD7F32' };
const medalLabel = { 0: '🥇', 1: '🥈', 2: '🥉' };
const podioAltura = { 0: 200, 1: 160, 2: 130 };   // altura visual de cada columna del podio

const lanzarConfetti = () => {
  const lanzar = (angle, origin) => confetti({
    particleCount: 80, angle, spread: 70, origin,
    colors: ['#ff9900', '#ffffff', '#FFD700'],
  });
  lanzar(60,  { x: 0, y: 0.75 }); lanzar(120, { x: 1, y: 0.75 });
  setTimeout(() => { lanzar(60, { x: 0, y: 0.75 }); lanzar(120, { x: 1, y: 0.75 }); }, 400);
  setTimeout(() => { lanzar(60, { x: 0, y: 0.75 }); lanzar(120, { x: 1, y: 0.75 }); }, 800);
  setTimeout(() => { lanzar(60, { x: 0, y: 0.75 }); lanzar(120, { x: 1, y: 0.75 }); }, 1200);
};

const lanzarConfettiPodio = () => {
  // Un solo disparo desde el centro, 60 partículas totales
  confetti({
    particleCount: 60,
    spread:        100,
    origin:        { x: 0.5, y: 0.4 },
    colors:        ['#FFD700', '#ff9900', '#ffffff'],
    gravity:       0.8,       // caen más rápido → menos tiempo en pantalla
    scalar:        1.1,
    ticks:         180,       // duración en frames (~3s a 60fps) en lugar de 250 por defecto
  });

  // Dos cañones laterales ligeros con delay
  setTimeout(() => {
    confetti({ particleCount: 30, angle: 60,  spread: 55, origin: { x: 0, y: 0.7 }, colors: ['#FFD700', '#ff9900', '#ffffff'], ticks: 150 });
    confetti({ particleCount: 30, angle: 120, spread: 55, origin: { x: 1, y: 0.7 }, colors: ['#FFD700', '#ff9900', '#ffffff'], ticks: 150 });
  }, 600);
};

// ── Modal de inicio de ronda ─────────────────────────────────────────────────
const ModalRonda = ({ fase, onClose }) => {
  const [saliendo,   setSaliendo]   = useState(false);
  const [pantalla,   setPantalla]   = useState(fase === 1 ? 'bienvenida' : 'ronda');

  const textos = {
    1: { titulo: '¡Comienza la Ronda 1!', sub: 'Fase Clasificatoria', desc: '20 participantes compiten por los 10 mejores lugares' },
    2: { titulo: '¡Comienza la Ronda 2!', sub: 'Semifinal',           desc: 'Los 10 mejores disputan los 3 lugares finalistas' },
    3: { titulo: '¡Comienza la Ronda 3!', sub: 'Gran Final',          desc: 'Los 3 finalistas se enfrentan por el podio' },
  }[fase];

  const handleClose = () => {
    setSaliendo(true);
    setTimeout(onClose, 400);
  };

  const handleIniciar = () => setPantalla('ronda');

  return (
    <div style={{
      ...M.overlay,
      opacity:    saliendo ? 0 : 1,
      transform:  saliendo ? 'scale(1.04)' : 'scale(1)',
      transition: 'opacity 0.4s ease, transform 0.4s ease',
    }}>
      <div style={M.card}>
        <div style={M.ring} />

        {/* ── Pantalla de bienvenida (solo fase 1) ── */}
        {pantalla === 'bienvenida' && (
          <>
            <div style={M.bienvenidaIcon}>🏆</div>
            <div style={M.titulo}>¡Bienvenidos!</div>
            <div style={M.sub}>Competencia de Lectura Veloz</div>
            <div style={M.desc}>
              Esta competencia consta de 3 rondas. Los mejores lectores
              demostrarán velocidad y comprensión para llegar al podio final.
              ¡Que comience la competencia!
            </div>
            <button onClick={handleIniciar} style={M.btnIniciar}>
              Iniciar competencia →
            </button>
          </>
        )}

        {/* ── Pantalla de ronda ── */}
        {pantalla === 'ronda' && (
          <>
            <div style={M.numRonda}>{fase}</div>
            <div style={M.titulo}>{textos.titulo}</div>
            <div style={M.sub}>{textos.sub}</div>
            <div style={M.desc}>{textos.desc}</div>
            <button onClick={handleClose} style={M.btnCerrar}>Continuar</button>
          </>
        )}

      </div>
    </div>
  );
};

// ── Pantalla de Podio Final ──────────────────────────────────────────────────
const PodioFinal = ({ ranking }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Entrada con delay para que el fade-in sea notorio
    const t = setTimeout(() => {
      setVisible(true);
      lanzarConfettiPodio();
    }, 200);
    return () => clearTimeout(t);
  }, []);

  // Reordenar para mostrar 2º - 1º - 3º (pirámide visual)
  const orden = [1, 0, 2];

  return (
    <div style={{
      ...P.root,
      opacity:   visible ? 1 : 0,
      transform: visible ? 'translateY(0)' : 'translateY(30px)',
      transition: 'opacity 0.8s ease, transform 0.8s ease',
    }}>

      {/* Encabezado */}
      <div style={P.headerWrap}>
        <FontAwesomeIcon icon={faTrophy} style={{ color: '#FFD700', fontSize: 36 }} />
        <div style={P.headerTextos}>
          <span style={P.headerSub}>Competencia de Lectura Veloz</span>
          <span style={P.headerTitulo}>Podio Final</span>
        </div>
        <FontAwesomeIcon icon={faTrophy} style={{ color: '#FFD700', fontSize: 36 }} />
      </div>

      {/* Plataforma del podio */}
      <div style={P.podioWrap}>
        {orden.map((posReal) => {
          const p     = ranking[posReal];
          const iel   = calcularIEL(p.ppm, p.comprension).toFixed(1);
          const color = medalColor[posReal];
          const alto  = podioAltura[posReal];
          const es1ro = posReal === 0;

          return (
            <div key={p.id} style={P.columnaWrap}>

              {/* Tarjeta del participante — flota sobre la plataforma */}
              <div style={{
                ...P.tarjeta,
                borderColor: color,
                transform: visible
                  ? 'translateY(0) scale(1)'
                  : 'translateY(20px) scale(0.95)',
                transition: `opacity 0.6s ease ${posReal * 0.15}s, transform 0.6s ease ${posReal * 0.15}s`,
                opacity: visible ? 1 : 0,
                boxShadow: es1ro ? `0 0 40px ${color}33` : 'none',
              }}>
                <div style={{ fontSize: es1ro ? 48 : 36 }}>{medalLabel[posReal]}</div>
                <div style={{ ...P.tarjetaNombre, fontSize: es1ro ? 20 : 16 }}>{p.nombre}</div>
                <div style={{ ...P.tarjetaIEL, color }}>
                  {iel} <span style={P.tarjetaIELLabel}>IEL</span>
                </div>
                <div style={P.tarjetaStats}>
                  ⚡ {p.ppm} ppm &nbsp;·&nbsp; 🧠 {p.comprension}%
                </div>
              </div>

              {/* Plataforma */}
              <div style={{
                ...P.plataforma,
                height:      alto,
                background:  `linear-gradient(180deg, ${color}33 0%, ${color}15 100%)`,
                borderTop:   `3px solid ${color}`,
                borderColor: color,
              }}>
                <span style={{ ...P.plataformaNum, color }}>{posReal + 1}°</span>
              </div>

            </div>
          );
        })}
      </div>

      {/* Stats finales */}
      <div style={P.statsRow}>
        {ranking.map((p, idx) => (
          <div key={p.id} style={{ ...P.statCard, borderColor: medalColor[idx] }}>
            <span style={{ ...P.statPos, color: medalColor[idx] }}>{medalLabel[idx]}</span>
            <span style={P.statNombre}>{p.nombre}</span>
            <span style={{ ...P.statIEL, color: medalColor[idx] }}>{calcularIEL(p.ppm, p.comprension).toFixed(1)} IEL</span>
          </div>
        ))}
      </div>

    </div>
  );
};

// ── Componente principal ─────────────────────────────────────────────────────
const PanelFinalCompetenciaLectura = () => {

  const estadoGuardado = recuperarEstado();
  
  // const [fase, setFase]                   = useState(1);
  // const [vista, setVista]                 = useState('feed');
  // const [mensajes, setMensajes]           = useState(mensajesPruebaqa);
  // const [ranking, setRanking]             = useState([]);
  // const [usuariosActivos, setUsuariosActivos] = useState(0);
  // const [wsStatus, setWsStatus]           = useState('connecting');
  const [fase,            setFase]           = useState(estadoGuardado?.fase      ?? 1);
  const [vista,           setVista]          = useState(estadoGuardado?.vista     ?? 'feed');
  const [mensajes,        setMensajes]       = useState(estadoGuardado?.mensajes  ?? mensajesPruebaqa);
  const [ranking,         setRanking]        = useState(estadoGuardado?.ranking   ?? []);
  const [usuariosActivos, setUsuariosActivos]= useState(0);
  const [wsStatus,        setWsStatus]       = useState('connecting');

  const [modalRonda,      setModalRonda]     = useState(!estadoGuardado);
  const [podioFinal,      setPodioFinal]     = useState(estadoGuardado?.podioFinal ?? false);
  const feedRef = useRef(null);

  const META           = fase === 1 ? 20 : fase === 2 ? 10 : 3;
  const TOMAR          = fase === 1 ? 10 : 3;
  const puedeCalificar = mensajes.length >= META;

  

  const handleCalificar = async () => {
  const top = [...mensajes]
    .sort((a, b) => calcularIEL(b.ppm, b.comprension) - calcularIEL(a.ppm, a.comprension))
    .slice(0, TOMAR);
  setRanking(top);

  if (fase === 1) await guardarResultadosFinal({ top });
  if (fase === 2) await actualizarResultadosFinal({ top });

  if (fase === 3) {
    limpiarEstado();   // ✅ competencia terminada, limpiar persistencia
    setPodioFinal(true);
    lanzarConfettiPodio();
    return;
  }

    setVista('resultados');
    lanzarConfetti();
  };

  const handleSiguienteFase = () => {
    const nuevaFase = fase + 1;
    setMensajes(ranking);
    setRanking([]);
    setFase(nuevaFase);
    setVista('feed');
    setModalRonda(true);   // ← dispara el modal de la nueva ronda
  };

  const statusLabel = {
    connecting: 'Conectando al servidor',
    open:       'Conectado · globalclickmexico.com',
    closed:     'Conexión cerrada',
    error:      'Error de conexión',
  }[wsStatus];

  const tituloResultados =
    fase === 1 ? 'Mejores 10 participantes' :
    fase === 2 ? 'Finalistas — Top 3'       : 'Podio Final';

     // WebSocket
  useEffect(() => {
    const ws = new WebSocket('wss://qawebsocket.globalclickmexico.com/ws');
    ws.onopen  = () => setWsStatus('open');
    ws.onclose = () => setWsStatus('closed');
    ws.onerror = () => setWsStatus('error');
    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.type === 'activos') setUsuariosActivos(data.payload.text);
      if (data.type === 'message') {
        setMensajes(prev => [...prev, {
          id:          crypto.randomUUID(),
          nombre:      data.payload.nombre,
          ppm:         data.payload.ppm,
          comprension: data.payload.comprension,
          fecha:       data.payload.fecha,
          idPerfil:    data.payload.idPerfil,
          lecturaRand: data.payload.lecturaRand,
        }]);
      }
    };
    return () => ws.close();
  }, []);

  useEffect(() => {
    if (feedRef.current) feedRef.current.scrollTop = feedRef.current.scrollHeight;
  }, [mensajes]);

  // Guardar en localStorage cada vez que cambia algo importante
  useEffect(() => {
    guardarEstado({ fase, vista, mensajes, ranking, podioFinal });
  }, [fase, vista, mensajes, ranking, podioFinal]);

  // ── Pantalla de podio final (reemplaza todo) ─────────────────────────────
  if (podioFinal) {
    return (
      <div style={styles.root}>
        <div style={styles.header}>
          <div style={styles.liveBadge}>
            <span style={styles.liveDot} />
            <span style={styles.liveLabel}>En vivo</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
            <Image src={require('@assets/images/uvegActualizado.png')} width="130" alt="uveg" />
            <Image src={require('@assets/images/logo-gc-horizontal.png')} width="130" alt="Global click" />
          </div>
          <div style={{ width: 130 }} />
        </div>
        <PodioFinal ranking={ranking} />
      </div>
    );
  }

  // ── Render normal ────────────────────────────────────────────────────────
  return (
    <div style={styles.root}>

      {/* Modal de inicio de ronda */}
      {modalRonda && (
        <ModalRonda fase={fase} onClose={() => setModalRonda(false)} />
      )}

      {/* ── Header ── */}
      <div style={styles.header}>
        <div style={styles.liveBadge}>
          <span style={styles.liveDot} />
          <span style={styles.liveLabel}>En vivo</span>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
            <Image src={require('@assets/images/uvegActualizado.png')} width="130" alt="uveg" />
            <Image src={require('@assets/images/logo-gc-horizontal.png')} width="130" alt="Global click" />
          </div>
          <div style={styles.faseIndicador}>
            {[1, 2, 3].map(f => (
              <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <div style={{
                  ...styles.fasePaso,
                  background: fase >= f ? '#ff9900' : 'rgba(255,255,255,0.12)',
                  color:      fase >= f ? '#00152a' : 'rgba(255,255,255,0.3)',
                }}>{f}</div>
                <span style={{
                  fontSize: 10,
                  color:      fase >= f ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.25)',
                  fontWeight: fase === f ? 700 : 400,
                }}>
                  {f === 1 ? 'Clasificatoria (20)' : f === 2 ? 'Semifinal (10)' : 'Gran Final (3)'}
                </span>
                {f < 3 && <span style={{ color: 'rgba(255,255,255,0.2)', fontSize: 12, margin: '0 4px' }}>→</span>}
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={styles.usersBadge}>
            <span style={styles.usersCount}>{usuariosActivos}</span>
            <span style={styles.usersLabel}>activos</span>
          </div>
          {vista === 'feed' && puedeCalificar && (
            <button onClick={handleCalificar} style={styles.btnCalificar}>
              <FontAwesomeIcon icon={faTrophy} style={{ marginRight: 7 }} />
              Calificar
            </button>
          )}
          {vista === 'resultados' && fase === 1 && (
            <button onClick={handleSiguienteFase} style={styles.btnSiguiente}>Fase 2 →</button>
          )}
          {vista === 'resultados' && fase === 2 && (
            <button onClick={handleSiguienteFase} style={styles.btnSiguiente}>Final →</button>
          )}
        </div>
      </div>

      {/* ── Vista: Feed ── */}
      {vista === 'feed' && (
        <div ref={feedRef} style={styles.feed}>
          {mensajes.length === 0 ? (
            <div style={{ ...styles.empty, gridColumn: '1 / -1' }}>
              <FontAwesomeIcon icon={faWifi} size="2x" color="rgba(255,255,255,0.2)" />
              <span style={styles.emptyText}>
                {fase === 1 && 'Esperando participantes de la fase clasificatoria…'}
                {fase === 2 && 'Esperando a los 10 clasificados para la final…'}
                {fase === 3 && 'Esperando la prueba decisiva de los 3 finalistas…'}
              </span>
            </div>
          ) : (
            mensajes.map((mensaje) => (
              <div key={mensaje.id} style={styles.messageCard}>
                <div>
                  <h4 style={styles.cardNombre}>{mensaje.nombre}</h4>
                  <div style={styles.cardStat}>⚡ {mensaje.ppm} palabras/min</div>
                  <div style={styles.cardStat}>🧠 {mensaje.comprension}% comprensión</div>
                  <div style={{ ...styles.cardStat, color: 'rgba(255,153,0,0.8)', marginTop: 4, fontSize: 12 }}>
                    IEL: {calcularIEL(mensaje.ppm, mensaje.comprension).toFixed(1)}
                  </div>
                </div>
                <div style={styles.liveBadgeComplete}>
                  <span style={styles.liveDotComplete} />
                  <span style={styles.liveLabelComplete}>Completado</span>
                </div>
              </div>
            ))
          )}

          {puedeCalificar && (
            <div style={{ ...styles.unlockBanner, gridColumn: '1 / -1' }}>
              <FontAwesomeIcon icon={faTrophy} style={{ color: '#ff9900', marginRight: 8 }} />
              <span>
                {fase === 1 && '¡20 participantes registrados! Puedes obtener los 10 mejores.'}
                {fase === 2 && '¡10 finalistas registrados! Puedes obtener el Top 3.'}
                {fase === 3 && '¡Los 3 finalistas completaron la prueba! Puedes definir el podio.'}
              </span>
            </div>
          )}

          <div style={{ ...styles.progresoBarra, gridColumn: '1 / -1' }}>
            <div style={{ ...styles.progresoRelleno, width: `${Math.min((mensajes.length / META) * 100, 100)}%` }} />
          </div>
          <div style={{ ...styles.progresoLabel, gridColumn: '1 / -1' }}>
            {mensajes.length} / {META} participantes
          </div>
        </div>
      )}

      {/* ── Vista: Resultados ── */}
      {vista === 'resultados' && (
        <div style={styles.feedResultados}>
          <div style={styles.top10Header}>
            <FontAwesomeIcon icon={faTrophy} style={{ color: '#ff9900', fontSize: 22 }} />
            <span style={styles.top10Title}>{tituloResultados}</span>
          </div>

          {/* ✅ Grid centrado que se adapta a la cantidad de items */}
          <div style={{
            display:               'grid',
            gridTemplateColumns:   `repeat(${Math.min(ranking.length, fase === 1 ? 2 : 3)}, minmax(0, 420px))`,
            gap:                   10,
            justifyContent:        'center',   // ← centra el grid completo
            overflowY:             'auto',
            flex:                  1,
            alignContent:          'start',
          }}>
            {ranking.map((p, idx) => {
              const iel       = calcularIEL(p.ppm, p.comprension).toFixed(1);
              const esMedalla = fase === 2 && idx < 3;
              return (
                <div key={p.id} style={{
                  ...styles.top10Card,
                  borderLeft: `4px solid ${esMedalla ? medalColor[idx] : 'rgba(255,153,0,0.25)'}`,
                  background:  esMedalla
                    ? `rgba(${idx === 0 ? '255,215,0' : idx === 1 ? '192,192,192' : '205,127,50'},0.07)`
                    : 'rgba(255,255,255,0.04)',
                }}>
                  <div style={{ ...styles.top10Pos, color: esMedalla ? medalColor[idx] : 'rgba(255,255,255,0.35)' }}>
                    {esMedalla ? medalLabel[idx] : `#${idx + 1}`}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={styles.top10Nombre}>{p.nombre}</div>
                    <div style={styles.top10Stats}>⚡ {p.ppm} ppm &nbsp;·&nbsp; 🧠 {p.comprension}%</div>
                  </div>
                  <div style={styles.top10Puntaje}>
                    <span style={{ fontSize: 18, fontWeight: 700, color: '#ff9900' }}>{iel}</span>
                    <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginTop: 1 }}>IEL</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── Footer ── */}
      <div style={styles.footer}>
        <div style={{ ...styles.wsDot, background: wsStatus === 'open' ? '#22c55e' : 'rgba(255,255,255,0.25)' }} />
        <span style={styles.wsLabel}>{statusLabel}</span>
        <span style={styles.msgCount}>
          {mensajes.length} / {META} {mensajes.length === 1 ? 'participante' : 'participantes'} · Fase {fase}{fase === 3 ? ' — Gran Final' : ''}
        </span>

         <button
          onClick={() => {
            if (window.confirm('¿Reiniciar competencia? Se perderán todos los datos guardados.')) {
              limpiarEstado();
              window.location.reload();
            }
          }}
          style={styles.btnReset}
        >
          Reiniciar
        </button>
      </div>

    </div>
  );
};

// ── Estilos modal ────────────────────────────────────────────────────────────
const M = {
  btnReset: {
    background:   'transparent',
    border:       '1px solid rgba(255,255,255,0.1)',
    borderRadius: 12,
    padding:      '3px 10px',
    color:        'rgba(255,255,255,0.2)',
    fontSize:     10,
    cursor:       'pointer',
    fontFamily:   'inherit',
    letterSpacing:'0.03em',
    transition:   'color 0.2s, border-color 0.2s',
  },
  bienvenidaIcon: {
    fontSize:   64,
    lineHeight: 1,
    marginBottom: 4,
  },
  btnIniciar: {
    marginTop:     12,
    background:    '#ff9900',
    border:        'none',
    borderRadius:  20,
    padding:       '10px 32px',
    color:         '#00152a',
    fontSize:      14,
    fontWeight:    700,
    cursor:        'pointer',
    fontFamily:    "'Space Grotesk', system-ui, sans-serif",
    letterSpacing: '0.03em',
  },
  overlay: {
    position:        'fixed',
    inset:           0,
    zIndex:          1000,
    background:      'rgba(0,10,20,0.85)',
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    backdropFilter:  'blur(4px)',
  },
  card: {
    background:    '#00152a',
    border:        '1px solid rgba(255,153,0,0.35)',
    borderRadius:  24,
    padding:       '48px 56px',
    display:       'flex',
    flexDirection: 'column',
    alignItems:    'center',
    gap:           12,
    maxWidth:      480,
    width:         '90%',
    position:      'relative',
    overflow:      'hidden',
  },
  ring: {
    position:     'absolute',
    top:          -60,
    left:         '50%',
    transform:    'translateX(-50%)',
    width:        200,
    height:       200,
    borderRadius: '50%',
    border:       '40px solid rgba(255,153,0,0.06)',
    pointerEvents:'none',
  },
  numRonda: {
    fontSize:      96,
    fontWeight:    700,
    lineHeight:    1,
    color:         '#ff9900',
    fontFamily:    "'Space Grotesk', system-ui, sans-serif",
    letterSpacing: '-0.04em',
  },
  titulo: {
    fontSize:      28,
    fontWeight:    700,
    color:         '#ffffff',
    textAlign:     'center',
    letterSpacing: '-0.02em',
    fontFamily:    "'Space Grotesk', system-ui, sans-serif",
  },
  sub: {
    fontSize:      13,
    fontWeight:    700,
    color:         '#ff9900',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    fontFamily:    "'Space Grotesk', system-ui, sans-serif",
  },
  desc: {
    fontSize:   14,
    color:      'rgba(255,255,255,0.45)',
    textAlign:  'center',
    lineHeight: 1.5,
    fontFamily: "'Space Grotesk', system-ui, sans-serif",
    marginTop:  4,
  },
  barraWrap: {
    width:        '100%',
    height:       3,
    background:   'rgba(255,255,255,0.08)',
    borderRadius: 2,
    overflow:     'hidden',
    marginTop:    16,
  },
  barra: {
    height:    '100%',
    width:     '100%',
    background:'#ff9900',
    borderRadius: 2,
    animation: 'shrink 4s linear forwards',
    // La animación se define en un <style> global abajo
  },
  btnCerrar: {
    marginTop:     8,
    background:    'transparent',
    border:        '1px solid rgba(255,153,0,0.35)',
    borderRadius:  20,
    padding:       '8px 28px',
    color:         'rgba(255,255,255,0.6)',
    fontSize:      13,
    fontWeight:    600,
    cursor:        'pointer',
    fontFamily:    "'Space Grotesk', system-ui, sans-serif",
    letterSpacing: '0.04em',
  },
};

// ── Estilos podio ────────────────────────────────────────────────────────────
const P = {
  root: {
    flex:           1,
    display:        'flex',
    flexDirection:  'column',
    alignItems:     'center',
    justifyContent: 'center',
    gap:            32,
    padding:        '24px 32px',
    overflowY:      'auto',
  },
  headerWrap: {
    display:    'flex',
    alignItems: 'center',
    gap:        16,
  },
  headerTextos: {
    display:       'flex',
    flexDirection: 'column',
    alignItems:    'center',
    gap:           2,
  },
  headerSub: {
    fontSize:      12,
    fontWeight:    700,
    color:         'rgba(255,153,0,0.7)',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    fontFamily:    "'Space Grotesk', system-ui, sans-serif",
  },
  headerTitulo: {
    fontSize:      36,
    fontWeight:    700,
    color:         '#ffffff',
    letterSpacing: '-0.02em',
    fontFamily:    "'Space Grotesk', system-ui, sans-serif",
  },
  podioWrap: {
    display:        'flex',
    alignItems:     'flex-end',
    justifyContent: 'center',
    gap:            16,
    width:          '100%',
    maxWidth:       700,
  },
  columnaWrap: {
    display:       'flex',
    flexDirection: 'column',
    alignItems:    'center',
    flex:          1,
  },
  tarjeta: {
    background:    'rgba(255,255,255,0.04)',
    border:        '1px solid',
    borderRadius:  16,
    padding:       '20px 16px',
    display:       'flex',
    flexDirection: 'column',
    alignItems:    'center',
    gap:           6,
    width:         '100%',
    marginBottom:  8,
  },
  tarjetaNombre: {
    fontWeight:  700,
    color:       '#ffffff',
    textAlign:   'center',
    lineHeight:  1.2,
    fontFamily:  "'Space Grotesk', system-ui, sans-serif",
  },
  tarjetaIEL: {
    fontSize:   24,
    fontWeight: 700,
    lineHeight: 1,
    fontFamily: "'Space Grotesk', system-ui, sans-serif",
  },
  tarjetaIELLabel: {
    fontSize:      12,
    fontWeight:    700,
    opacity:       0.6,
    letterSpacing: '0.08em',
  },
  tarjetaStats: {
    fontSize:  12,
    color:     'rgba(255,255,255,0.45)',
    textAlign: 'center',
    fontFamily:"'Space Grotesk', system-ui, sans-serif",
  },
  plataforma: {
    width:          '100%',
    borderRadius:   '8px 8px 0 0',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
  },
  plataformaNum: {
    fontSize:      32,
    fontWeight:    700,
    fontFamily:    "'Space Grotesk', system-ui, sans-serif",
    letterSpacing: '-0.02em',
  },
  statsRow: {
    display: 'flex',
    gap:     12,
    width:   '100%',
    maxWidth:700,
  },
  statCard: {
    flex:          1,
    background:    'rgba(255,255,255,0.04)',
    border:        '1px solid',
    borderRadius:  12,
    padding:       '12px 16px',
    display:       'flex',
    flexDirection: 'column',
    gap:           3,
  },
  statPos:    { fontSize: 20 },
  statNombre: { fontSize: 14, fontWeight: 700, color: '#ffffff', fontFamily: "'Space Grotesk', system-ui, sans-serif" },
  statIEL:    { fontSize: 13, fontWeight: 700, fontFamily: "'Space Grotesk', system-ui, sans-serif" },
};

// ── Estilos panel principal (igual que antes + feedResultados) ───────────────
const styles = {
  root: {
    background:    '#00152a',
    overflow:      'hidden',
    fontFamily:    "'Space Grotesk', system-ui, sans-serif",
    display:       'flex',
    height:        '100vh',
    flexDirection: 'column',
  },
  header: {
    background:   '#00152a',
    borderBottom: '1px solid rgba(255,153,0,0.25)',
    padding:      '14px 20px',
    display:      'flex',
    alignItems:   'center',
    justifyContent:'space-between',
    gap:          12,
  },
  liveBadge: {
    display:    'flex',
    alignItems: 'center',
    gap:        7,
    background: 'rgba(255,153,0,0.12)',
    border:     '1px solid rgba(255,153,0,0.35)',
    borderRadius:20,
    padding:    '4px 12px 4px 8px',
    flexShrink: 0,
  },
  liveDot: {
    display:      'inline-block',
    width:        8,
    height:       8,
    background:   '#ff9900',
    borderRadius: '50%',
  },
  liveLabel: {
    fontSize:      11,
    fontWeight:    700,
    letterSpacing: '0.1em',
    color:         '#ff9900',
    textTransform: 'uppercase',
  },
  faseIndicador: { display: 'flex', alignItems: 'center', gap: 6, marginTop: 2 },
  fasePaso: {
    width:          20,
    height:         20,
    borderRadius:   '50%',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    fontSize:       10,
    fontWeight:     700,
    flexShrink:     0,
  },
  liveBadgeComplete: {
    display:     'flex',
    alignItems:  'center',
    gap:         7,
    background:  'rgba(102,255,0,0.12)',
    border:      '1px solid rgba(81,255,0,0.35)',
    borderRadius:20,
    padding:     '4px 12px 4px 8px',
    flexShrink:  0,
  },
  liveDotComplete:  { display: 'inline-block', width: 8, height: 8, background: '#00ff22', borderRadius: '50%' },
  liveLabelComplete:{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', color: '#5eff00', textTransform: 'uppercase' },
  usersBadge: {
    display:     'flex',
    alignItems:  'center',
    gap:         5,
    background:  'rgba(255,255,255,0.06)',
    border:      '1px solid rgba(255,255,255,0.12)',
    borderRadius:20,
    padding:     '4px 12px',
    flexShrink:  0,
  },
  usersCount: { fontSize: 13, fontWeight: 700, color: '#ffffff' },
  usersLabel: { fontSize: 11, color: 'rgba(255,255,255,0.4)', letterSpacing: '0.04em' },
  btnCalificar: {
    display:      'flex',
    alignItems:   'center',
    background:   '#ff9900',
    color:        '#00152a',
    border:       'none',
    borderRadius: 20,
    padding:      '7px 18px',
    fontSize:     13,
    fontWeight:   700,
    cursor:       'pointer',
    fontFamily:   'inherit',
  },
  btnSiguiente: {
    background:   'rgba(255,153,0,0.15)',
    color:        '#ff9900',
    border:       '1px solid rgba(255,153,0,0.4)',
    borderRadius: 20,
    padding:      '6px 16px',
    fontSize:     12,
    fontWeight:   700,
    cursor:       'pointer',
    fontFamily:   'inherit',
  },
  feed: {
    flex:                1,
    overflowY:           'auto',
    padding:             '12px 16px',
    display:             'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gridAutoRows:        'min-content',
    gap:                 12,
    alignContent:        'start',
  },
  // Vista resultados: flex column, ocupa todo el alto
  feedResultados: {
    flex:          1,
    overflow:      'hidden',
    padding:       '12px 16px',
    display:       'flex',
    flexDirection: 'column',
    gap:           8,
  },
  empty: {
    flex:          1,
    display:       'flex',
    flexDirection: 'column',
    alignItems:    'center',
    justifyContent:'center',
    gap:           12,
    padding:       32,
  },
  emptyText:    { fontSize: 14, color: 'rgba(255,255,255,0.2)', textAlign: 'center' },
  messageCard: {
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'space-between',
    background:     '#011122',
    border:         '1px solid rgba(255,153,0,0.15)',
    borderLeft:     '3px solid #ff9900',
    borderRadius:   10,
    padding:        '12px 16px',
  },
  cardNombre: { color: '#ffffff', fontWeight: 700, margin: '0 0 4px', fontSize: 15 },
  cardStat:   { color: 'rgba(255,255,255,0.7)', fontSize: 13, marginTop: 2 },
  unlockBanner: {
    display:     'flex',
    alignItems:  'center',
    background:  'rgba(255,153,0,0.1)',
    border:      '1px solid rgba(255,153,0,0.3)',
    borderRadius:10,
    padding:     '12px 16px',
    color:       'rgba(255,255,255,0.8)',
    fontSize:    13,
    fontWeight:  500,
    marginTop:   4,
  },
  progresoBarra: {
    height:      3,
    background:  'rgba(255,255,255,0.08)',
    borderRadius:2,
    overflow:    'hidden',
    marginTop:   8,
  },
  progresoRelleno: {
    height:     '100%',
    background: '#ff9900',
    borderRadius:2,
    transition: 'width 0.4s ease',
  },
  progresoLabel: { fontSize: 11, color: 'rgba(255,255,255,0.25)', textAlign: 'right', marginTop: 4 },
  top10Header: {
    display:      'flex',
    alignItems:   'center',
    gap:          10,
    paddingBottom:12,
    borderBottom: '1px solid rgba(255,153,0,0.2)',
    marginBottom: 4,
  },
  top10Title:  { fontSize: 18, fontWeight: 700, color: '#ffffff', letterSpacing: '-0.01em' },
  top10Card: {
    display:    'flex',
    alignItems: 'center',
    gap:        14,
    borderRadius:10,
    padding:    '12px 16px',
    border:     '1px solid transparent',
  },
  top10Pos:    { fontSize: 20, fontWeight: 700, minWidth: 36, textAlign: 'center' },
  top10Nombre: { fontSize: 15, fontWeight: 700, color: '#ffffff', marginBottom: 3 },
  top10Stats:  { fontSize: 12, color: 'rgba(255,255,255,0.5)' },
  top10Puntaje:{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', minWidth: 48 },
  footer: {
    background: 'rgba(255,255,255,0.03)',
    borderTop:  '1px solid rgba(255,255,255,0.06)',
    padding:    '9px 16px',
    display:    'flex',
    alignItems: 'center',
    gap:        8,
  },
  wsDot:    { width: 7, height: 7, borderRadius: '50%', flexShrink: 0 },
  wsLabel:  { fontSize: 11, color: 'rgba(255,255,255,0.3)', flex: 1, letterSpacing: '0.03em' },
  msgCount: { fontSize: 11, color: 'rgba(255,153,0,0.5)' },
};

// Keyframe para la barra de auto-cierre del modal — inyectado una sola vez
// if (typeof document !== 'undefined' && !document.getElementById('ks-shrink')) {
//   const tag = document.createElement('style');
//   tag.id = 'ks-shrink';
//   tag.textContent = `@keyframes shrink { from { width: 100% } to { width: 0% } }`;
//   document.head.appendChild(tag);
// }

export default PanelFinalCompetenciaLectura;